<template>
  <div class="investment-list">
    <div class="investment-wrapper">
      <div class="investment-banner">
        <div class="investment-title">{{ type == 'flexible' ? $t('flexibleTitle') : $t('fixedTitle') }}</div>
        <div class="banner-label">{{ $t('balance') }}</div>
        <div class="banner-number">{{ balanceAmount | formatMoney }}</div>
        <div class="banner-label">{{ type == 'flexible' ? $t('flexibleRevenue') : $t('fixedRevenue') }}</div>
        <div class="banner-number">{{ revenueAmount | formatMoney }}</div>
      </div>
      <div class="investment-container">
        <md-tabs
          ref="tabs"
          v-model="activeName"
        >
          <md-tab-pane name="ongoing" :label="titles[0]">
            <record-list :recordList="recordList.ongoing"></record-list>
          </md-tab-pane>
          <md-tab-pane name="completed" :label="titles[1]">
            <record-list :recordList="recordList.completed"></record-list>
          </md-tab-pane>
        </md-tabs>
      </div>
    </div>
    <div class="investment-footer" @click="goToProduct">
      {{ $t('investNow') }}
    </div>
  </div>
</template>

<script>
import { Field, Tabs, TabPane } from 'mand-mobile'
import RecordList from '@/components/user/RecordList'

export default {
  i18n: {
    messages: {
      en: {
        flexibleTitle: 'Flexible Investment',
        fixedTitle: 'Fixed Term Investment',
        balance: 'Balance',
        flexibleRevenue: 'Total Revenue',
        fixedRevenue: 'Expected return',
        ongoing: 'Ongoing',
        completed: 'Completed',
        investNow: 'Invest Now',
      },
      id: {
        flexibleTitle: 'Pendanaan Fleksibel',
        fixedTitle: 'Pendanaan Berjangka',
        balance: 'Nominal',
        flexibleRevenue: 'Total Pendapatan',
        fixedRevenue: 'Pendapatan',
        ongoing: 'Sedang berlangsung',
        completed: 'Selesai',
        investNow: 'Mulai Pendanaan',
      },
    },
  },
  components: {
    [Field.name]: Field,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    RecordList,
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.capitalAmount = {
        ongoing: { balance: 0, revenue: 0 },
        completed: { balance: 0, revenue: 0 },
      }
      vm.recordList = {
        ongoing: [],
        completed: [],
      }
      // vm.$refs.tabs.selectTab(0)
      vm.reloadRecordList()
      next()
    })
  },
  data() {
    return {
      activeName: 'ongoing',
      titles: [this.$t('ongoing'), this.$t('completed')],
      capitalAmount: {
        ongoing: { balance: 0, revenue: 0 },
        completed: { balance: 0, revenue: 0 },
      },
      recordList: {
        ongoing: [],
        completed: [],
      },
    }
  },
  computed: {
    type() {
      return this.$route.params.type
    },
    balanceAmount() {
      return this.capitalAmount[this.activeName].balance || 0
    },
    revenueAmount() {
      return this.capitalAmount[this.activeName].revenue || 0
    },
  },
  methods: {
    goToProduct() {
      this.$router.push({ name: this.type === 'flexible' ? 'FlexibleProduct' : 'Product' })
    },
    async reloadRecordList() {
      try {
        const params = {
          flexible: this.type === 'flexible',
          pageNum: 1,
          pageSize: 1000,
        }
        const response = await this.$http.get('/order/list', { params })
        let data = response.data.data
        let capital = {
          ongoing: { balance: 0, revenue: 0 },
          completed: { balance: 0, revenue: 0 },
        }
        let recordList = {
          ongoing: [],
          completed: [],
        }
        data.forEach(value => {
          value.productName = value.productName[this.$i18n.locale] || ''
          if (value.fundingStatus === 'REPAID') {
            recordList.completed.push(value)
            capital.completed.balance += value.amount + value.currentRevenue + value.extraAmount + value.extraCurrentRevenue
            capital.completed.revenue += value.currentRevenue + value.extraCurrentRevenue
          } else {
            recordList.ongoing.push(value)
            capital.ongoing.balance += value.amount + value.currentRevenue + value.extraAmount + value.extraCurrentRevenue
            capital.ongoing.revenue += value.currentRevenue + value.extraCurrentRevenue
          }
        })
        this.capitalAmount.ongoing = capital.ongoing
        this.capitalAmount.completed = capital.completed
        this.recordList.ongoing = recordList.ongoing
        this.recordList.completed = recordList.completed
      } catch (error) {
        console.error(error)
      }
    },
  },
}
</script>

<style scoped lang="stylus">
.investment-wrapper {
  padding-bottom: 60px;
}

.investment-banner {
  padding: 20px;
  color: #fff;
  background-color: color-primary;
  .investment-title {
    font-size: 21px;
    line-height: 28px;
    font-weight: bold;
  }
  .banner-label {
    font-size: 14px;
    margin: 20px 0 10px;
  }
  .banner-number {
    font-size: 16px;
    font-weight: bold;
  }
}

.investment-container /deep/ {
  padding-top: 10px;
  background-color: #f9f9f9;
  padding-bottom: 50px;
  .md-tabs {
    background-color: #fff;
  }
}

.investment-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.24);
  font-size: 16px;
  font-weight: 500;
  color: color-primary;
  line-height: 60px;
  text-align: center;
}
</style>
